export default "__VITE_ASSET__CBbuvYgf__"